"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { CurrentAccountIdProvider } from "@zapier/identity";
import { UniversalLayout } from "@zapier/universal-layout";
import * as Sentry from "@sentry/react";

import {
  TrackRouting,
  initializeDatadogRum,
  initializeSentry,
  nextJsReportWebVitals,
} from "../observability";
import { isDatadog } from "../utils/isDatadog";
import emitEvent from "src/observability/tracking/emitEvent";
import { OneTrustCookieConsentScript } from "./OneTrustCookieConsentScript";
import type { FullStoryUser } from "src/observability/FullStory/FullStory";

interface Props {
  children: ReactNode;
  user?: FullStoryUser;
}

const shouldInitSentry = !isDatadog();
if (shouldInitSentry) {
  initializeSentry({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || "",
    commitHash: process.env.NEXT_PUBLIC_COMMIT_SHA || "",
    environment: process.env.NEXT_PUBLIC_APP_ENV || "",
  });
}

// const UniversalLayout = withSSR(dynamic, () => {
//   return experimentallyImportRemoteModule({
//     dependencies: {
//       react: React,
//       "@emotion/react": emotion,
//       "@zapier/design-system": ds,
//     },
//   }).then((mod) => {
//     return mod.UniversalLayout;
//   });
// });

// Measure and report web vitals that Next.js tracks to Datadog.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
initializeDatadogRum();
export const reportWebVitals = nextJsReportWebVitals;

function AppLayout({ children }: Props) {
  const pathname = usePathname();
  const shouldShowSimplifiedFooter = pathname?.startsWith("/app/");

  return (
    <CurrentAccountIdProvider>
      <TrackRouting>
        <UniversalLayout
          currentUrl={pathname || ""}
          mainContentId="templates"
          trackEvent={emitEvent as (eventName: string, data?: any) => void}
          showSimplifiedFooter={shouldShowSimplifiedFooter}
          shouldSidebarBeInitiallyCollapsed={true}
        >
          {children}
        </UniversalLayout>
        <OneTrustCookieConsentScript />
      </TrackRouting>
    </CurrentAccountIdProvider>
  );
}

export default Sentry.withProfiler(AppLayout);
